
import { showVuePopup } from '../../utils/showVuePopup';
import Profile from '../../popup/Profile.vue';
import WalletDeposit from '../../popup/WalletDeposit.vue';
import { useAuthStore } from '../../stores/auth';
import { storeToRefs } from 'pinia';
import Register from '../../popup/Register.vue';
import Login from '../../popup/Login.vue';
import { formatCurrency } from '../../utils/currency';
import { useWebStore } from '../../stores/web';
import { onMounted, onUpdated, ref } from 'vue';
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast';
import { useSession } from '../../stores/session';

export default {
	name: 'PopupMainNavbar',
	components: {
		Button,
	},
	methods: { formatCurrency },
	setup() {
		const auth = useAuthStore()
		auth.hydrate()
		const {profile, isLoggedIn} = storeToRefs(auth);

		const web = useWebStore();
		web.hydrate()

		const session = useSession();

		const toast = useToast();

		onMounted(() => {
			if (isLoggedIn) {
				auth.fetchData();
			}
			web.fetchPrefix();
			web.fetchPrefixPermission();
		})

		const btnLoading = ref<boolean>(false);
		const btnClickProfile = async () => {
			session.set('navbar_primary', 'profile');
			await showVuePopup(Profile);
		}

		const btnClickWalletDeposit = async () => {
			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:deposit');
			await showVuePopup(WalletDeposit);
		}

		const btnClickRegister = async () => {
			await showVuePopup(Register);
		}

		const btnClickLogin = async () => {
			await showVuePopup(Login, {}, {
				customClass: {
					popup: 'bg-[url(https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/bg-login.webp)] bg-size-[110%_100%] bg-center bg-transparent',
				},
			});
		}

		const btnRefProfile = async () => {
			btnLoading.value = true;
			try {
				await auth.fetchData();
				toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'อัพเดตโปรไฟล์เรียบร้อยแล้ว', life: 3000 });
			} catch (error: any) {
				const message = error?.message || 'ไม่สามารถอัพเดตโปรไฟล์ได้';
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาด',
					detail: message,
					life: 3000,
				});
				console.error('Fetch profile error:', error);
			} finally {
				btnLoading.value = false;
			}
		};

		const btnClickLogout = async () => {
			if (!confirm('ต้องการออกจากระบบ ใช่ หรือ ไม่?')) return;

			try {
				await auth.logout();
				toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'ออกจากระบบสำเร็จ', life: 3000 });
			} catch (error: any) {
				const message = error?.message || 'ออกจากระบบไม่สำเร็จ';
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาด',
					detail: message,
					life: 3000,
				});
				console.error('Fetch profile error:', error);
			} finally {
				btnLoading.value = false;
			}
		}

		return {
			auth,
			profile,
			isLoggedIn,
			btnLoading,
			btnClickProfile,
			btnClickWalletDeposit,
			btnClickRegister,
			btnClickLogin,
			btnRefProfile,
			btnClickLogout,
		}
	}
}
